import { register } from "register-service-worker";
import { Notify } from "quasar";
import { major, minor } from "semver";
import { i18n } from "@/boot/i18n";
import { config } from "@/utils/config";

// This is the version of the currently running application, set in build time from package.json.
const CURRENT_VERSION = import.meta.env.APP_VERSION;

// The ready(), registered(), cached(), updatefound() and updated()
// events passes a ServiceWorkerRegistration instance in their arguments.
// ServiceWorkerRegistration: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerRegistration
register(import.meta.env.QUASAR_SERVICE_WORKER_FILE, {
  // The registrationOptions object will be passed as the second argument
  // to ServiceWorkerContainer.register()
  // https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register#Parameter

  // registrationOptions: { scope: "./" },

  
  ready(registration) {
    // Send config to the service worker.
    registration.active?.postMessage({ type: 'SET_CONFIG', config })       
    if (import.meta.env.QUASAR_DEV) {
      console.log("App is being served from cache by a service worker.");
    }
  },

  registered(/* registration */) {
    if (import.meta.env.QUASAR_DEV) {
       
      console.log("Service worker has been registered.");
    }
  },

  cached(/* registration */) {
    if (import.meta.env.QUASAR_DEV) {
       
      console.log("Content has been cached for offline use.");
    }
  },

  updatefound(/* registration */) {
    if (import.meta.env.QUASAR_DEV) {
       
      console.log("New content is downloading.");
    }
  },

  updated(registration) {
    if (import.meta.env.QUASAR_DEV) {
       
      console.log("New content is available; please inspect.");
    }
    // A new service worker has been downloaded and is waiting.
    // We need to ask it for its version.
    const worker = registration.waiting;
    if (!worker) {
      return;
    }

    // Create a communication channel to the waiting service worker
    const channel = new MessageChannel();
    channel.port1.onmessage = (event) => {
      if (event.data && event.data.version) {
        const newVersion = event.data.version as string;

        if (import.meta.env.QUASAR_DEV) {
           
          console.log(`Update available. Current: ${CURRENT_VERSION}, New: ${newVersion}`);
        }

        // A breaking change is when the major or minor version changes.
        const isBreaking = major(newVersion) != major(CURRENT_VERSION) ||
                           minor(newVersion) != minor(CURRENT_VERSION);

        if (isBreaking) {
          if (import.meta.env.QUASAR_DEV) {
             
            console.log("Breaking change detected. Prompting user.");
          }
          Notify.create({
            message: i18n.global.t('appUpdateAvailable'),
            timeout: 0, // persistent
            type: 'info',
            actions: [
              {
                label: i18n.global.t('update'),
                color: 'white',
                handler: () => {
                  if (import.meta.env.QUASAR_DEV) {
                    console.log("User accepted update. Activating new service worker.");
                  }

                  reloadOnControllerChange = true;
                  // Ask the waiting service worker to take control.
                  worker.postMessage({ type: 'SKIP_WAITING' });
                }
              },
              {
                label: i18n.global.t('dismiss'),
                color: 'white',
                handler: () => {}
              }
            ]
          });
        } else {
          if (import.meta.env.QUASAR_DEV) {
             
            console.log("Non-breaking change detected. New version will be active on next refresh.");
          }
          // For non-breaking changes, we do nothing. The new service worker
          // will be installed but will wait. It will activate automatically
          // when the user closes all tabs and re-opens the app.
        }
      }
    };

    // Send the message to the waiting service worker, passing the second port
    worker.postMessage({ type: 'GET_VERSION' }, [channel.port2]);
  },

  offline() {
    if (import.meta.env.QUASAR_DEV) {
       
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    }
  },

  error(err) {
    if (import.meta.env.QUASAR_DEV) {
       
      console.error("Error during service worker registration:", err);
    }
  }
});

// Listen for the controllerchange event. This fires when the service worker
// controlling the page changes, for example, after a call to skipWaiting().
let reloadOnControllerChange = false;

navigator.serviceWorker.addEventListener('controllerchange', () => {
  // Only reload if the controller change was triggered by our update button.
  if (reloadOnControllerChange) {
    if (import.meta.env.QUASAR_DEV) {
       
      console.log('Controller changed after user update. Reloading the page.');
    }
    window.location.reload();
  } else {
    if (import.meta.env.QUASAR_DEV) {
       
      console.log('Controller changed naturally. No reload needed.');
    }
  }
});

